import React, { useEffect, useMemo, useState } from "react";
import { TableAdv } from "../../../../../components";
import { useDispatch, useSelector } from "react-redux";
import { recruiterEmailDelivaryReportStart } from "../../../../../redux/slices/reports/reportsSlice";
import { getTotalCountApi } from "../../../../../redux/slices/totalCount/totalCountApi";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import { formatWords2 } from "../../../../../utils/stringUtils";
import { usePagination } from "../../../../../hooks";

const EmailMerges = ({ applicantId }) => {
  const dispatch = useDispatch();
  const { recruiterEmailDelivaryReport, loading, error } = useSelector( (state) => state.reports );
  const [totalCount, setTotalCount] = useState(0);
  const { page, limit, setPage, handleLimitChange } = usePagination( 25, (newPage, newLimit) => {} );

  const getTotalCount = async () => {
    const res = await getTotalCountApi({
      collection: "candidateemaillogs",
      coll: "CandidateEmailLog",
      filters: {
        candidateId: { type: "NONE", value: applicantId }
      },
      app: "ats"
    })
    if (res?.success) {
      setTotalCount(res?.data?.data || 0)
    }
  };

  useEffect(() => {
    if (!applicantId) return;

    dispatch(
      recruiterEmailDelivaryReportStart({
        coll: "CandidateEmailLog",
        fil: { candidateId: { type: "NONE", value: applicantId } },
        extret: "uiid firstName lastName role",
        ref: 'JobPost',
        incl: 'uiid jobInfo',
        limit: limit,
        page: page,
      })
    );
  }, [dispatch, applicantId, limit, page]);

  useEffect(() => {
    if (!applicantId) return;
    getTotalCount();
  }, [applicantId])

  const mappedRows = useMemo(() => {
    if (!Array.isArray(recruiterEmailDelivaryReport)) return [];
    
    return recruiterEmailDelivaryReport?.map(item => ({
      recruiter: `${formatWords2(item?.addedBy?.firstName)} ${formatWords2(item?.addedBy?.lastName)}`,
      emailsentfrom: item?.from,
      jobCode: item?.jobPostId?.jobInfo?.jobCode,
      addedOn: dayjs(item.addedOn).format("YYYY-MM-DD HH:mm"),
      emailCount: 1
    }));
  }, [recruiterEmailDelivaryReport]);

  const columns = [
    { key: "recruiter", label: "Recruiter" },
    { key: "emailsentfrom", label: "Email Sent From" },
    { key: "jobCode", label: "Job Code",
      render: (row) => (
        <Link
          to="/ats/jobs/job-details"
          className="text-info"
          onClick={() => {
            sessionStorage.setItem("selectedJobUiid", row.jobPostId);
            sessionStorage.setItem(
              "prevJobsPage",
              window.location.pathname + window.location.search
            );
          }}
        >
          {row.jobCode}
        </Link>
      )
    },
    { key: "addedOn", label: "Last Email Sent" },
    { key: "emailCount", label: "Email Count" },
  ];

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;
  if (!applicantId) return <p>Select a candidate to view emails</p>;

  return (
    <TableAdv
      columns={columns}
      rows={mappedRows}
      singleSelection
      totalCount={totalCount}
      onPaginationChange={setPage}
      onLimitChange={handleLimitChange}
      showSlNo={true}
      serverPagination
    />
  );
};

export default EmailMerges;
